module.exports = __webpack_public_path__ + "static/disney-24c03dc0a540223ac40048508f60696e.png";